import React from "react"
import { Image as ChakraImage, Box, HStack } from "@chakra-ui/react"
import { WalletPassBlock } from "sharedTypes/builder"
import { useCurrentEvent } from "queries/events"
import { walletBadgeSrcSet } from "utilities/walletPassBadges"

/** Both badges always show here — the canvas is a design surface, and which one
 * a guest actually receives is decided when the email is sent. */
const WalletPass = ({ block: { data } }: { block: WalletPassBlock }) => {
  const { data: { language: eventLanguage } } = useCurrentEvent()
  const language = data.localizeToEventLanguage ? eventLanguage : data.language

  return (
    <Box
      bgColor={data.blockColor}
      pt={`${data.paddingTop * 4}px`}
      pb={`${data.paddingBottom * 4}px`}
    >
      <HStack spacing={2.5} justify="center">
        <ChakraImage
          {...walletBadgeSrcSet("apple", language)}
          alt="Add to Apple Wallet"
          h="40px"
        />
        <ChakraImage
          {...walletBadgeSrcSet("google", language)}
          alt="Add to Google Wallet"
          h="40px"
        />
      </HStack>
    </Box>
  )
}

export default WalletPass
